import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { Logo } from "./Logo";
import { goTo } from "@/lib/api";
import { INSTAGRAM } from "@/lib/press-data";

const LINKS = [["cycle", "Cycle tracking"], ["kitchen", "Body-type nutrition"], ["pillars", "Faith & zodiac"], ["demo", "Try the demo"]];

export const Footer = () => (
  <footer className="relative overflow-hidden bg-[#2C221E] pt-20 text-[#FBF5EE]" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
      <div className="flex flex-col justify-between gap-12 md:flex-row">
        <div className="max-w-sm">
          <Logo light />
          <p className="mt-5 text-sm leading-relaxed text-[#d9c7bd]">A cycle and lifestyle companion for body, soul, style and sky. Made with care for women of every faith.</p>
          <a href={INSTAGRAM.url} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link"
            className="mt-6 inline-flex items-center gap-2 rounded-full border border-[#F4DED3]/30 px-4 py-2 text-sm font-semibold text-[#F4DED3] transition-colors hover:border-white hover:text-white">
            <Instagram className="h-4 w-4" /> {INSTAGRAM.handle}
          </a>
        </div>
        <ul className="grid grid-cols-2 gap-x-12 gap-y-3 text-sm">
          {LINKS.map(([id, l]) => (
            <li key={id}><a href={`#${id}`} onClick={(e) => { e.preventDefault(); goTo(id); }} data-testid={`footer-link-${id}`} className="text-[#F4DED3] transition-colors hover:text-white">{l}</a></li>
          ))}
          <li><Link to="/today" data-testid="footer-link-today" className="text-[#F4DED3] transition-colors hover:text-white">Today's word</Link></li>
          <li><Link to="/privacy" data-testid="footer-link-privacy" className="text-[#F4DED3] transition-colors hover:text-white">Privacy policy</Link></li>
          <li><Link to="/press" data-testid="footer-link-press" className="text-[#F4DED3] transition-colors hover:text-white">Press & creators</Link></li>
          <li><Link to="/creators" data-testid="footer-link-creators" className="text-[#F4DED3] transition-colors hover:text-white">Become a creator</Link></li>
        </ul>
      </div>
      <p className="mt-16 text-xs text-[#c9b6ab]">© {new Date().getFullYear()} Lunelle. Wellness guidance only — not a substitute for medical advice.</p>
    </div>
    <p aria-hidden="true" className="mt-6 select-none whitespace-nowrap text-center font-serif text-[26vw] font-light italic leading-[0.75] text-[#3A2D28]">Lunelle</p>
  </footer>
);
